'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReauthHandler;

var _performReauth = require('./performReauth');

var _performReauth2 = _interopRequireDefault(_performReauth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reauthDebouncerThreshold = 500; // in ms

function createReauthHandler(reauth, apiContext) {
  // Create a promise chain for reauth calls. Future reauth calls will tie into the chain, allowing
  // future calls requiring reauth to:
  // a) latch onto the latest reauth call being made if they are being performed in close time
  //    proximity to the first call initiating reauth; OR
  // b) perform a reauth call if enough time has passed since the last reauth
  //    (via `nextAllowedReauth`)
  var reauthPromise = Promise.resolve();
  var nextAllowedReauth = new Date().getTime();

  return function (apiHandler) {
    var reauthHandler = function reauthHandler() {
      nextAllowedReauth = new Date().getTime() + reauthDebouncerThreshold;

      return (0, _performReauth2.default)(reauth, apiContext);
    };

    if (new Date().getTime() < nextAllowedReauth) {
      var secondCallHandler = function secondCallHandler() {
        return apiHandler(reauthHandler);
      };

      reauthPromise = reauthPromise.then(secondCallHandler, secondCallHandler);

      return reauthPromise;
    }

    reauthPromise = reauthPromise.then(reauthHandler, reauthHandler);

    return reauthPromise;
  };
}
//# sourceMappingURL=createReauthHandler.js.map